import { create } from "zustand";
import axios from "axios";

const api = axios.create({
	baseURL: import.meta.env.VITE_API_URL || "http://localhost:8091/api/v1",
});

api.interceptors.request.use(
	(config) => {
		const token = JSON.parse(localStorage.getItem("auth-storage"))?.state?.token;
		if (token) {
			config.headers.Authorization = `Bearer ${token}`;
		}
		return config;
	},
	(error) => Promise.reject(error)
);

export const useSeatmapStore = create((set, get) => ({
	trainTypes: [],
	layouts: [],
	isLoading: false,
	error: null,

	clearError: () => set({ error: null }),

	fetchTrainTypes: async (includeInactive = false, category = null) => {
		set({ isLoading: true, error: null });
		try {
			const params = { include_inactive: includeInactive };
			if (category) {
				params.category = category;
			}
			const response = await api.get("/seatmaps/train-types", {
				params,
			});
			set({ trainTypes: response.data.items || [], isLoading: false });
		} catch (error) {
			set({
				error: error.message || "좌석배치도 열차종 조회 실패",
				isLoading: false,
			});
		}
	},

	createTrainType: async (payload) => {
		set({ isLoading: true, error: null });
		try {
			const response = await api.post("/seatmaps/train-types", payload);
			await get().fetchTrainTypes(true);
			set({ isLoading: false });
			return response.data.train_type || null;
		} catch (error) {
			set({ isLoading: false });
			throw new Error(error.message || "좌석배치도 열차종 생성 실패");
		}
	},

	updateTrainType: async (code, payload) => {
		set({ isLoading: true, error: null });
		try {
			const response = await api.put(`/seatmaps/train-types/${code}`, payload);
			await get().fetchTrainTypes(true);
			set({ isLoading: false });
			return response.data.train_type || null;
		} catch (error) {
			set({ isLoading: false });
			throw new Error(error.message || "좌석배치도 열차종 수정 실패");
		}
	},

	fetchLayouts: async (params = {}) => {
		set({ isLoading: true, error: null });
		try {
			const response = await api.get("/seatmaps/layouts", { params });
			set({ layouts: response.data.items || [], isLoading: false });
		} catch (error) {
			set({
				error: error.message || "좌석배치도 레이아웃 조회 실패",
				isLoading: false,
			});
		}
	},

	fetchLayout: async (layoutId) => {
		const response = await api.get("/seatmaps/layout", {
			params: { layout_id: layoutId },
		});
		return response.data.layout || null;
	},

	createLayout: async (payload) => {
		const response = await api.post("/seatmaps/layouts", payload);
		await get().fetchLayouts();
		return response.data.layout || null;
	},

	updateLayout: async (layoutId, payload) => {
		const response = await api.put(`/seatmaps/layouts/${layoutId}`, payload);
		await get().fetchLayouts();
		return response.data.layout || null;
	},

	deleteLayout: async (layoutId) => {
		set({ isLoading: true, error: null });
		try {
			await api.delete(`/seatmaps/layouts/${layoutId}`);
			await get().fetchLayouts();
			set({ isLoading: false });
			return true;
		} catch (error) {
			set({
				error: error.message || "좌석배치도 레이아웃 삭제 실패",
				isLoading: false,
			});
			throw error;
		}
	},
}));
